const iconButtonFileDownBtn = {
  title: 'Generate qrcode of this equipment'
};

export default iconButtonFileDownBtn;
